// import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './Home';
import About from './About';
import Team from './Team';
import Theses from './Theses';
import PhDTheses from './PhDTheses';
import MasterTheses from './MasterTheses';
import BScProjects from './BScProjects';
import Publications from './Publications';
import Projects from './Projects';
import ResearchAreas from './ResearchAreas';
import Noticias from './noticias';
import Eventos from './eventos';
import NotasPrensa from './notasPrensa';
import Ofertas from './ofertas';
import TransferenciaDeTecnologia from './Transf_tec';
import Sdg from './SDG';

// import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
	// <BrowserRouter basename={process.env.PUBLIC_URL}>
     <div className="App">
	 <Router>
	 <Routes>
	 <Route exact path="/" element={<Home />} />
	 <Route exact path="about" element={<About />} />
	 <Route exact path="team" element={<Team />} />
	 <Route exact path="phd-theses" element={<PhDTheses />} />
	 <Route exact path="master-theses" element={<MasterTheses />} />
	 <Route exact path="bsc-projects" element={<BScProjects />} />
	 <Route exact path="publications" element={<Publications />} />
	 <Route exact path="projects" element={<Projects />} />
	 <Route exact path="research-areas" element={<ResearchAreas />} />
	 <Route exact path="news" element={<Noticias />} />
	 <Route exact path="events" element={<Eventos />} />
	 <Route exact path="press-notes" element={<NotasPrensa />} />
	 <Route exact path="offers" element={<Ofertas />} />
	 <Route exact path="technology-transfer" element={<TransferenciaDeTecnologia />} />
	 <Route exact path="sdg" element={<Sdg />} />
	 </Routes>
	 </Router>
	 </div>
	//  </BrowserRouter>
  );
}

export default App;

